import { cloneElement, useRef, useState } from 'react'

import Flex from '@ui-pc/Flex'
import Icon from '@ui-pc/Icon'
import Switch from '@ui-pc/Switch'
import { cancelBubble } from '@utils/index'

export const VideoBox = (props: { children; size?; readonly? }) => {
  const { children, size, readonly } = props

  const [show, useShow] = useState(true)

  const ref = useRef<HTMLVideoElement>()

  // const ref2 = useRef<{ useShow; show }>({})

  const onClick = () => {
    if (readonly) return
    if (show) {
      useShow(false)
      ref.current.play()

      console.log('play')
    } else {
      useShow(true)
      ref.current.pause()
      console.log('pause')
    }
  }

  return (
    <div
      className="widget-preview-video-box"
      onTouchStart={onClick}
      onClick={onClick}>
      <div>
        {cloneElement(children, {
          ref,
          onClick(e) {
            e.preventDefault()
          },
          playsInline: true
        })}
      </div>
      <Switch either={show}>
        <Flex
          style={{ position: 'absolute' }}
          justify="center"
          alignItems="center">
          <div className="player">
            <Icon customSrc="icon-arrow-right-filling" />
          </div>
        </Flex>
      </Switch>
    </div>
  )
}
